import React, { useState } from 'react';
import { TextField, Button, Box, Grid, Select, InputLabel, MenuItem } from '@material-ui/core';
import { FormControl } from '@material-ui/core';
import { format } from "../commons/utils";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import useStyles from './useStyles'
import { ErrorMessage } from '@hookform/error-message'
import { singleInputValidator } from '../commons/utils';

import ReactGA from "react-ga";


const PasoUnoForm = ({ rut, setRut, nombre, setNombre, apellidoP, setApellidoP, apellidoM, setApellidoM, direccion, setDireccion, genero, setGenero, tipogenero, region, setRegion, ciudad, setCiudad, nombreRegion, nombreProvincia, comuna, setComuna, nombreComuna,  telefono, setTelefono, correo, setCorreo, aseguradora, setAseguradora, errors, setError, setData, setSpinner, isapres, setSexo, tiposexo, sexo}) => {

  const classes = useStyles();
  const [value, setValue] = React.useState(new Date('2014-08-18T21:11:54'));

  const handleChange = (event) => {
    setAseguradora(event.target.value);
  };

  const handleChangeRut = event => {
    setRut(format(event.target.value))
  }

  const handleChangeNombre = event => {
    setNombre(event.target.value)
  }

  const hanldeChangeApellidoP = event => {
    setApellidoP(event.target.value)
  }

  const hanldeChangeApellidoM = event => {
    setApellidoM(event.target.value)
  }

  const handleChangeGenero = (event) => {
    setGenero(event.target.value);

  };

  const handleChangeSexo = (event) => {
    setSexo(event.target.value);

  };

  const handleChangeRegion = (event) => {
    setRegion(event.target.value);
  }; 


  const handleChangeCiudad = (event) => {
    setCiudad(event.target.value);
  };
  const handleChangeComuna = (event) => {
    setComuna(event.target.value);
  };

  const handleChangeDireccion = event => {
    setDireccion(event.target.value)
  }

  const handleChangeTelefono = event => {
    setTelefono(event.target.value)
  }

  const handleChangeCorreo = event => {
    setCorreo(event.target.value)
  }

  const printRegion = () => {
    return nombreRegion.map((item,index)=>{
      return <MenuItem  key={index} value={item.region_id}>{item.region_nombre}</MenuItem>
    })
  }

  const printProvincia = () => {
    return nombreProvincia.map((item,index)=>{
      return <MenuItem  key={index} value={item.provincia_id}>{item.provincia_nombre}</MenuItem>
    })
  }
  const [subTitulo, setSubTitulo] = useState('Identificación del Cotizante y/o Beneficiario')

  const printAseguradoras = () => {
    return isapres.map((item,index)=>{
      return <MenuItem  key={index} value={item.codigo_isapre}>{item.nombre_isapre}</MenuItem>
    })
  }
  

  const printComuna = () => {
    return nombreComuna.map((item,index)=>{
     // console.log("item", item)
      return <MenuItem  key={index} value={item.comuna_id}>{item.comuna_nombre}</MenuItem>
    })
  }

  const printGenero = () => {
    return tipogenero.map((item,index)=>{
      return <MenuItem  key={index} value={item.id}>{item.descripcion}</MenuItem>
    })
  }

  const printSexo = () => {
    return tiposexo.map((item,index)=>{
      return <MenuItem  key={index} value={item.id}>{item.descripcion}</MenuItem>
    })
  }
  //ReactGA.pageview('/paso1');
  ReactGA.event({
  category: 'Solicitud de mediación para controversias con Isapre y Fonasa',
  action : 'Inicio de la solicitud de sediación para controversias con Isapre y Fonasa', 
  label : 'Trámite - ID 0300520001'
});
  return (
    <>
      {/* aca va el sub titulo del formulario */}
      <Box display="flex" justifyContent="start">
        <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', marginLeft: 45 }}>{subTitulo}</h3>
      </Box>
      {/* cuerpo para inputs, puede ser mas de un grid dependiendo de las filas que se necesite */}
      <Grid>

        <FormControl className={classes.formControlComponent}>
          <TextField 
          onChange={() => singleInputValidator(rut,"Rut",setError, [{option:'rutValidation', updateFields:true}], setData, setSpinner)}
          /*onChange={handleChangeRut} */
          /*onBlur={() => singleInputValidator(rut,"Rut",setError, [{option:'rutValidation', updateFields:true}], setData, setSpinner)} */
          id="input-id" 
          variant="outlined" 
          label="Rut" 
          size="small" 
          name="Rut" 
          value={rut} />
          <ErrorMessage
            style={{ color: 'red' }}
            name="Rut"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent}>
          <TextField onChange={handleChangeNombre} onBlur={() => {
            setNombre(nombre.trim())
            singleInputValidator(nombre,"Nombre",setError, [])
            }} id="input-id" variant="outlined" label="Nombre" size="small" name="Nombre" value={nombre} />
          <ErrorMessage
            style={{ color: 'red' }}
            name="Nombre"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent}>
          <TextField onChange={hanldeChangeApellidoP} onBlur={() => {
            setApellidoP(apellidoP.trim())
            singleInputValidator(apellidoP,"apellidoP",setError, [])
          }} value={apellidoP} name="apellidoP" id="input-id" variant="outlined" label="Apellido Paterno" size="small" />
          <ErrorMessage
            style={{ color: 'red' }}
            name="apellidoP"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent}>
          <TextField onChange={hanldeChangeApellidoM} onBlur={() => {
            setApellidoM(apellidoM.trim())
            singleInputValidator(apellidoM,"apellidoM",setError, [])
          }} value={apellidoM} name="apellidoM" id="input-id" variant="outlined" label="Apellido Materno" size="small" />
          <ErrorMessage
            style={{ color: 'red' }}
            name="apellidoM"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent} size="small">
         <InputLabel id="selectlabelGenero" variant="outlined" >Genero</InputLabel>
          <Select
            required
            labelId="generolabel"
            id="selectlabelGenero"
            variant="outlined"
            value={genero}
            label="Genero"
            onChange={handleChangeGenero}
            name="genero"
            
          >
            {printGenero()}
          </Select>
          <ErrorMessage
            style={{ color: 'red' }}
            name="genero"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent} size="small">
         <InputLabel id="selectlabelGenero" variant="outlined" >Sexo</InputLabel>
          <Select
            required
            labelId="generolabel"
            id="selectlabelGenero"
            variant="outlined"
            value={sexo}
            label="Sexo"
            onChange={handleChangeSexo}
            name="genero"
            
          >
            {printSexo()}
          </Select>
          <ErrorMessage
            style={{ color: 'red' }}
            name="sexo"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent}  size="small">
            <InputLabel id="regionlabel"  variant="outlined" >Región</InputLabel>
                <Select
                required
                labelId="regionlabel"
                id="regionlabel"
                variant="outlined"
                value={region}
                label="Región"
                onChange={handleChangeRegion}
          
                name="region"
                >
                {printRegion()}
                </Select>
                <ErrorMessage
                  style={{ color: 'red' }}
                  name="region"
                  as="div"
                  errors={errors}
                />
          </FormControl>

  
          <FormControl className={classes.formControlComponent}  size="small">
          <InputLabel id="selectlabelComuna"  variant="outlined" >Comuna</InputLabel>
                <Select
                required
                labelId="comunalabel"
                id="selectlabelComuna"
                variant="outlined"
                value={comuna}
                label="Comuna"
                onChange={handleChangeComuna}
              
                name="comuna"
                >
                     {printComuna()}
                </Select>
                <ErrorMessage
                  style={{ color: 'red' }}
                  name="comuna"
                  as="div"
                  errors={errors}
                />
          </FormControl>

        <FormControl className={classes.formControlComponent}>
          <TextField onChange={handleChangeDireccion} onBlur={() => {
            setDireccion(direccion.trim())
            singleInputValidator(direccion,"direccion",setError, [])
          }} value={direccion} name="direccion" id="input-id" variant="outlined" label="Dirección" size="small" />
          <ErrorMessage
            style={{ color: 'red' }}
            name="direccion"
            as="div"
            errors={errors}
          />
        </FormControl>

        <FormControl className={classes.formControlComponent}>
              <TextField onChange={handleChangeTelefono} onBlur={() => {
                setTelefono(telefono.trim())
                singleInputValidator(telefono,"telefono",setError, [])
              }} value={telefono} name="telefono" id="input-id" variant="outlined" type="number"  label="Teléfono" size="small" />
              <ErrorMessage
                style={{ color: 'red' }}
                name="telefono"
                as="div"
                errors={errors}
              />
        </FormControl>
        
        <FormControl className={classes.formControlComponent}>
          <TextField onChange={handleChangeCorreo} onBlur={() => {
            setCorreo(correo.trim())
            singleInputValidator(correo,"correo",setError, [{option:'eMail'}])
          }} value={correo} name="correo" id="input-id" variant="outlined" label="Correo" size="small" />
          <ErrorMessage
            style={{ color: 'red' }}
            name="correo"
            as="div"
            errors={errors}
          />
        </FormControl>


        <FormControl className={classes.formControlComponent} size="small">

          <InputLabel id="selectlabelAseguradora" variant="outlined" >Aseguradora</InputLabel>
          <Select
            required
            labelId="aseguradoralabel"
            id="selectlabelAseguradora"
            variant="outlined"
            value={aseguradora}
            label="Aseguradora"
            onChange={handleChange}
            name="aseguradora"
            onBlur={() => singleInputValidator(aseguradora,"aseguradora",setError, [])}
          >
            {printAseguradoras()}
          </Select>
          <ErrorMessage
            style={{ color: 'red' }}
            name="aseguradora"
            as="div"
            errors={errors}
          />

        </FormControl>
        <FormControl className={classes.formControlComponent} size="small"></FormControl>
      </Grid>
    </>
  )
}

export default PasoUnoForm